// extracted by mini-css-extract-plugin
export default {"namedIconImage":"NameWithIconCellRenderer_namedIconImage__E7FKT"};